import { Theme } from '@mui/material/styles';

import { makeStyles } from 'tss-react/mui';

/** Profile + posts layout aligned with `User.styles.ts`. */
export const useStyles = makeStyles<Theme>()((theme) => ({
  communityInfoWrapper: {
    ...theme.mixins.appContainer,
    display: 'flex',
    gap: 8,
    marginBottom: 8,
  },
  avatar: {},
  communityDetails: {
    flex: 1,
    display: 'flex',
    flexDirection: 'column',
    gap: theme.spacing(1),
  },
  info: {
    flex: 1,
    display: 'flex',
    flexDirection: 'column',
    gap: theme.spacing(1),
  },
  description: {
    color: theme.palette.text.secondary,
  },
  actions: {
    display: 'flex',
    justifyContent: 'flex-start',
    flexWrap: 'wrap',
    gap: 8,
  },
  requestsButtonInner: {
    display: 'inline-flex',
    alignItems: 'center',
    gap: theme.spacing(1),
  },
  requestCountBadge: {
    display: 'inline-flex',
    alignItems: 'center',
    justifyContent: 'center',
    minWidth: theme.spacing(2.75),
    height: theme.spacing(2.75),
    paddingLeft: theme.spacing(0.5),
    paddingRight: theme.spacing(0.5),
    borderRadius: '50%',
    fontSize: theme.typography.pxToRem(12),
    fontWeight: 700,
    lineHeight: 1,
    color: theme.palette.primary.main,
    backgroundColor: theme.palette.primary.contrastText,
  },
  lockedProfileInfo: {
    display: 'flex',
    alignItems: 'center',
    gap: theme.spacing(0.75),
  },
  lockedProfileIcon: {
    width: 18,
    height: 18,
    color: theme.palette.text.secondary,
    flexShrink: 0,
  },
  noAccessText: {
    color: theme.palette.text.secondary,
    fontWeight: 500,
  },
  privatePostsContainer: {
    ...theme.mixins.appContainer,
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    textAlign: 'center',
    gap: theme.spacing(1),
    padding: theme.spacing(2),
    marginBottom: theme.spacing(1),
  },
  privatePostsIconWrapper: {
    width: 132,
    height: 132,
    borderRadius: '50%',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    backgroundColor:
      theme.palette.mode === 'dark'
        ? 'hsl(220 15% 20%)'
        : theme.palette.background.default,
    [theme.breakpoints.down('sm')]: {
      width: 108,
      height: 108,
    },
  },
  privatePostsIcon: {
    width: 96,
    height: 96,
    color: theme.palette.text.secondary,
    [theme.breakpoints.down('sm')]: {
      width: 80,
      height: 80,
    },
  },
  privatePostsTitle: {
    fontWeight: 600,
  },
  privatePostsDescription: {
    maxWidth: 480,
    color: theme.palette.text.secondary,
  },
  communityDetailsWrapper: {
    display: 'flex',
    flexDirection: 'row',
    gap: theme.spacing(1),
    [theme.breakpoints.down('md')]: {
      flexDirection: 'column-reverse',
    },
  },
  communityPostsWrapper: {
    flex: 2,
  },
  communityRelationsWrapper: {
    width: '100% !important',
    display: 'flex',
    flexDirection: 'column',
    gap: 4,
    flex: 1,
  },
  communityRelationsContainer: {
    ...theme.mixins.appContainer,
    ...theme.mixins.appContainersSpacing,
  },
  communityRelationsHeader: {
    display: 'flex',
    gap: 8,
    color: theme.palette.text.primary,
    textDecoration: 'unset',
    '&:hover': {
      color: theme.palette.primary.main,
    },
  },
  communityRelationsCounter: {
    fontWeight: 600,
    marginLeft: theme.spacing(0.5),
    color: theme.palette.grey[600],
  },
}));
